import PrimaryAccountUser from '@/common/containers/Forms/PrimaryAccountUser/PrimaryAccountUser';

export default PrimaryAccountUser;
